var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnassignedTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#BCCCDC",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.714c0 7.393-8 8.598-8 10.286-.36-1.696-8-3.214-8-10.286C2 4.454 5.582 1 10 1s8 3.454 8 7.714z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.05 11.492c0-.52.065-.933.194-1.242.129-.309.383-.646.762-1.014.383-.37.625-.634.726-.79.157-.239.235-.497.235-.774 0-.367-.092-.647-.276-.838-.18-.195-.445-.293-.796-.293-.336 0-.608.096-.815.287-.203.188-.305.443-.305.768H7.352c.007-.692.242-1.239.703-1.64.465-.403 1.078-.604 1.84-.604.785 0 1.396.199 1.834.597.44.399.662.955.662 1.67 0 .637-.297 1.264-.891 1.881l-.72.709c-.258.293-.391.72-.4 1.283H9.05zm-.099 1.822c0-.23.072-.416.217-.556.145-.145.34-.217.586-.217.25 0 .447.074.592.223.144.144.216.328.216.55 0 .215-.07.395-.21.54-.141.144-.34.216-.598.216-.258 0-.457-.072-.598-.216-.136-.145-.205-.325-.205-.54z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedTask);
export default __webpack_public_path__ + "static/media/unassigned-task.edb82be22d9fb38f96be16868575029e.svg";
export { ForwardRef as ReactComponent };